import React from 'react';
import { ISuppliersQueryParams, IQueryResult, ISupplier } from 'gen/ApiClient';
import { IQueryContext } from 'framework/context/IQueryContext';

export const SuppliersQueryContext = React.createContext<IQueryContext<IQueryResult<ISupplier>, ISuppliersQueryParams>>(undefined as any);
